import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// Icons
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import GroupsIcon from "@mui/icons-material/Groups";
import DomainIcon from "@mui/icons-material/Domain";
import ConstructionIcon from "@mui/icons-material/Construction";

const ApartmentLayoutPage = ({ data }) => {
  return (
    <Box sx={{ width: "100%", mb: 4, mt: 3 }}>
      {/* HERO SECTION */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          height: { md: "520px" },
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {/* LEFT: IMAGE */}
        <Box sx={{ flex: 6, position: "relative", backgroundColor: "#eee" }}>
          <TransformWrapper
            initialScale={1}
            minScale={0.7}
            maxScale={4}
            centerOnInit
            wheel={{ disabled: true }}
            doubleClick={{ disabled: true }}
            zoomAnimation={{ size: 0.3 }}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                {/* ZOOM CONTROLS */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    zIndex: 10,
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Tooltip title="Zoom In">
                    <IconButton onClick={() => zoomIn()}>
                      <ZoomInIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Zoom Out">
                    <IconButton onClick={() => zoomOut()}>
                      <ZoomOutIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Reset">
                    <IconButton onClick={() => resetTransform()}>
                      <RestartAltIcon />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* IMAGE */}
                <TransformComponent
                  wrapperStyle={{ width: "100%", height: "100%" }}
                  contentStyle={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={data.apartment.IconUrl}
                    alt="Project Layout"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      width: "auto",
                      height: "auto",
                      objectFit: "contain",
                      userSelect: "none",
                      pointerEvents: "none",
                    }}
                  />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </Box>

        {/* RIGHT: INFO PANEL */}
        <Box
          sx={{
            flex: 4,
            backgroundColor: "#fff",
            color: "black",
            p: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              {data.apartment.ApartmentName}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", mb: 5 }}>
              <LocationOnIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
              <Typography sx={{ opacity: 0.9 }}>{data.apartment.Address}</Typography> ,
              <Typography sx={{ opacity: 0.9 }}>{data.apartment.City}</Typography>
            </Box>

            {data?.apartment?.TotalUnits && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <GroupsIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Total Units:</strong> {data.apartment.TotalUnits}
                </Typography>
              </Box>
            )}



            {data?.apartment?.LandArea && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <CropSquareIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Total Land Area:</strong> {data.apartment.LandArea}
                </Typography>
              </Box>
            )}

            {data?.apartment?.TotalBlocks && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <DomainIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Total Blocks:</strong> {data.apartment.TotalBlocks}
                </Typography>
              </Box>
            )}

            {data?.apartment?.TotalFloors && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <ApartmentIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Total Floors:</strong> {data.apartment.TotalFloors}
                </Typography>
              </Box>
            )}

            {data?.apartment?.Construction_Status && (
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <ConstructionIcon sx={{ mr: 1, fontSize: 20, opacity: 0.8 }} />
                <Typography>
                  <strong>Construction Status:</strong>{" "}
                  {data.apartment.Construction_Status}
                </Typography>
              </Box>
            )}





          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ApartmentLayoutPage;
